import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    boxShadow: '0px 10px 20px rgb(0 0 0 / 10%)',
    borderRadius: 8,
    overflowX: 'scroll',
    position: 'relative',
  },
  search: {
    '& > div:nth-of-type(1)': {
      paddingRight: 16,
    },
    '& > div:nth-of-type(2)': {
      padding: '16px 16px 0 16px',
    },
  },
  grid: {
    borderTop: `1px solid ${colors.dividerSecondary}`,
  },
  pagination: {
    padding: '0px 16px',
    justifyContent: 'space-between',
    height: '72px',
    '& > ul': { flexFlow: 'nowrap' },
  },
});
